import "./UniqueNames.module.css";
import BrandNavigationHeader from "@/reusable_sections/Header";
import TheRareNameDirectory from "./sections/TheRareNameDirectory";
import CompanyDirectory from "@/reusable_sections/Footer";
export default function UniqueNamesPage() {
  return <div>
      <BrandNavigationHeader />
      <TheRareNameDirectory />
      <CompanyDirectory />
    </div>;
}